<template>
  <div class="scene-tabs">
    <el-tabs ref="tabs" :type="type" v-model="sceneIndex" @tab-click="tabClick" v-bind="$attrs"
      :before-leave="moreState" class="tabs-content" id="sceneTabs">
      <slot></slot>
      <el-tab-pane name="add" v-if="tabList.length && fn('1334')">
        <div slot="label">
          <el-divider direction="vertical"></el-divider>
          <el-button type="text" class="tab-item blueColor" @click="open">场景<i
              class="el-icon-plus el-icon--right"></i></el-button>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="operate" v-if="screen">
      <el-tooltip effect="dark" content="筛选设置，点击可添加筛选条件" placement="top">
        <i class="iconfont icon-shaixuan1" @click="openCondition"></i>
      </el-tooltip>
    </div>
    <div class="operate" v-if="hasRight">
      <slot name="right"></slot>
    </div>
  </div>
</template>
<script>
import { checkAuthority } from '@/utils'
export default {
  name: 'YblSceneTabs',
  model: {
    prop: 'scene',
    event: 'change'
  },
  props: {
    scene: {
      type: String | Number,
      default: () => ''
    },
    type: {
      type: String,
      default: () => ''
    },
    tabList: {
      type: Array,
      default: () => []
    },
    more: {
      type: Object,
      default: () => { }
    },
    screen: {
      type: Boolean,
      default: () => false
    },
    hasRight: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      sceneIndex: '',
      dataIndex: 0,
      fn: checkAuthority
    }
  },
  created () {
  },
  mounted () {
    this.sceneIndex = this.scene
  },
  methods: {
    tabClick (tab, event) {
      this.$emit('tab-click', this.sceneIndex, tab, event)
    },
    moreState (tab) {
      if ((tab === '6' && !this.more) || tab === 'add') {
        return false
      }
    },
    open () {
      this.$emit('open')
    },
    openCondition () {
      this.$emit('openCondition')
    }
  },
  watch: {
    'scene': function (newVal, oldVal) {
      console.log(this.scene)
      this.sceneIndex = this.scene
    },
    'more': function (newVal, oldVal) {
      this.sceneIndex = '6'
      console.log('sceneIndex', this.sceneIndex)
    }
  }
}
</script>
<style lang="less" scoped>
@import "../assets/less/color.less";
.scene-tabs {
  width: 100%;
  height: 100%;
  flex: 1;
  position: absolute;
  .tabs-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    /deep/.el-tabs__header {
      margin-bottom: 6px;
    }
    /deep/.el-tabs__content {
      flex: 1;
      width: 100%;
      height: 100%;
      overflow-y: auto;
      // margin-bottom: 10px;
      .el-tab-pane {
        width: 100%;
        height: 100%;
        position: absolute;
      }
    }
    /deep/.el-tabs__nav-wrap {
      &::after {
        height: 1px;
      }
    }
    /deep/.el-tabs__nav-scroll {
      padding-left: 15px;
    }
    /deep/.el-tabs__item {
      height: 48px;
      line-height: 48px;
      color: @routine-color;
      font-size: 13px;
      // padding: 0 15px;
      &.is-active {
        color: @color;
        .tab-item {
          color: @main-color;
        }
      }
    }
    /deep/.el-divider--vertical {
      margin-left: 0;
      margin-right: 25px;
    }
    /deep/.tab-item {
      color: @routine-color;
      font-size: 13px;
    }
    .blueColor {
      color: @color;
    }
  }
  .operate {
    position: absolute;
    right: 12px;
    top: 15px;
    font-size: 16px;
    color: #808080;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sceneTabs.vue